import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
export const ListItem = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={"mb-auto h-fit before:content-['\xB7']"} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <li className="ml-8 flex items-center gap-7 text-Gray-800 typo-body4">{t1}{children}</li>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};